export const QLP_TENANT = process.env.GATSBY_TENANT || 'vistaprint'
export const QLP_ENVIRONMENT = process.env.GATSBY_ENVIRONMENT as 'dev'
export const QLP_LOGGER_BASE_URL =
  process.env.GATSBY_LOGGER_BASE_URL ||
  'https://endpoint1.collection.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV3W4z2NbE4wJJJxM4r5mQ8GHI8IyA0STuuEb4Dj0zEf3V4fAqx7AD0tJ_16HCUAHSxw2Sgt70pCEcm7BMvSVvo6DiU9xO0hwm5aMsyJDZoksQ=='
